import { Delete } from '@workwave-tidal/core/icons'

import { preview } from '@/components/form/preview'
import { DownloadKML } from '@/icons'

import { useEditing } from '../../../../../../hooks/useEditing'
import { useActions } from '../hooks/useActions'
import { useGoBack } from '../hooks/useGoBack'
import { useTexts } from '../hooks/useTexts'
import { useDeleteTrafficAreaModal } from './../../../../../../../../modals/DeleteTrafficAreaModal'

interface Props {
  trafficAreas: uui.domain.client.rm.TrafficRegion[]
}

export function Header(props: Props) {
  const { trafficAreas } = props
  const actions = useActions()

  const goBack = useGoBack()

  const texts = useTexts()

  const { editingEntity } = useEditing('trafficArea')
  const inEdit = editingEntity !== 'none'

  const { Modal: DeleteTrafficAreaModal } = useDeleteTrafficAreaModal()

  return (
    <preview.Header
      title={texts.title(trafficAreas.length)}
      onClose={goBack}
      testId="traffic-area-view-header"
    >
      <preview.ActionBar>
        <preview.ActionBarItem
          icon={<DownloadKML size={24} />}
          key="close"
          onClick={actions.onExport}
          label={texts.exportKML}
          tooltip={texts.exportKML}
          disabled={inEdit}
          data-testid="setup-traffic__exportkml"
          disableWhenReadOnly={false}
        />
        <preview.ActionBarItem
          icon={<Delete />}
          key="close"
          onClick={actions.onDelete}
          label={texts.delete}
          tooltip={texts.delete}
          disableWhenReadOnly
          data-testid="setup-traffic__delete"
        />
      </preview.ActionBar>
      <DeleteTrafficAreaModal trafficAreas={trafficAreas.map(ta => ta.id)} />
    </preview.Header>
  )
}
